import { createAction } from 'utils/redux';

import { OPEN_CONSENT_MODAL, SAVE_TRACKING_PREFERENCES } from './constants';

export const saveTrackingPreferences = createAction(SAVE_TRACKING_PREFERENCES);
export const openConsentModal = createAction(OPEN_CONSENT_MODAL);
